import { setFormData } from "@/features/Forms/actions/setFormData";
import { updateUserSettings } from "@/features/User/actions/updateUserSettings";
import { Button, Checkbox, CheckboxGroup, Flex, FormLabel, Stack, useToast } from "@chakra-ui/react";
import React from "react";
import { formConstants } from "./FormConstants";
import { QuestionComponent } from "./QuestionComponent";

interface FormStepProps {
  onSubmit: () => void;
}

export const ProfileInfoStep: React.FC<FormStepProps> = (props) => {
  const { onSubmit } = props;
  const [selectedIndustry, setSelectedIndustry] = React.useState<string>("");
  const [selectedUseCases, setSelectedUseCases] = React.useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const toast = useToast();

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await setFormData("profile", {
        industry: selectedIndustry,
        useCases: selectedUseCases,
      });
      await updateUserSettings({
        isProfileSetupComplete: true,
      });
      onSubmit();
    } catch (error) {
      toast({
        position: "top",
        title: "Error",
        description: "Failed to save profile information. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Stack spacing="spacing-xl">
      <Flex gap="spacing-xs" direction={"column"}>
        <FormLabel mb="0">What is your industry?</FormLabel>
        <QuestionComponent
          placeholder="Select industry"
          field={{ name: "industry", value: selectedIndustry }}
          items={formConstants.ROLE_ANSWERS}
          setValue={(_, value) => setSelectedIndustry(value)}
        />
      </Flex>
      <Flex gap="spacing-xs" direction={"column"}>
        <FormLabel>What do you want to use Prompt Studio for?</FormLabel>
        <CheckboxGroup value={selectedUseCases} onChange={(val: string[]) => setSelectedUseCases(val)}>
          <Flex gap="spacing-xs" direction={"column"}>
            {formConstants.USECASE_ANSWERS.map((option) => (
              <Checkbox key={option} value={option} textStyle="label/S/regular">
                {option}
              </Checkbox>
            ))}
          </Flex>
        </CheckboxGroup>
      </Flex>
      <Button
        mt="spacing-xl"
        width="100%"
        onClick={handleSubmit}
        isLoading={isSubmitting}
        variant="primary"
        isDisabled={!selectedIndustry || selectedUseCases.length === 0}
      >
        Continue
      </Button>
    </Stack>
  );
};
